import type { KeyboardEvent } from 'react';
import { EmployerOverdueStatusIcon } from './EmployerOverdueStatusIcon';

type EmployerOverdueTasksCardProps = {
  count: number;
  title: string;
  countUnitLabel: string;
  viewLabel: string;
  viewAriaLabel: string;
  onView: () => void;
};

export const EmployerOverdueTasksCard = ({
  count,
  title,
  countUnitLabel,
  viewLabel,
  viewAriaLabel,
  onView,
}: EmployerOverdueTasksCardProps) => {
  if (count <= 0) {
    return null;
  }

  const handleViewKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onView();
    }
  };

  return (
    <article className="mb-5 flex items-center justify-between gap-3 rounded-2xl border border-red-200/80 bg-gradient-to-br from-red-50 to-red-100/40 p-4 shadow-sm dark:border-red-900/40 dark:from-red-950/30 dark:to-red-950/10">
      <div className="flex items-center gap-3">
        <EmployerOverdueStatusIcon variant="card" />
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold leading-snug text-red-800/90 dark:text-red-200/90">{title}</span>
          <div className="flex items-baseline gap-1">
            <span className="text-2xl font-black tabular-nums leading-none text-red-700 dark:text-red-200">
              {count > 99 ? '99+' : count}
            </span>
            <span className="text-xs text-red-700/80 dark:text-red-300/80">{countUnitLabel}</span>
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={onView}
        onKeyDown={handleViewKeyDown}
        tabIndex={0}
        className="shrink-0 rounded-xl bg-red-500 px-4 py-2 text-xs font-bold text-white shadow-sm shadow-red-500/20 hover:bg-red-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500"
        aria-label={viewAriaLabel}
      >
        {viewLabel}
      </button>
    </article>
  );
};
